import React from "react"
import "../components/wave.css"

let animation = process.env.GATSBY_USE_ANIMATION === "true"
let dividerName = process.env.GATSBY_DIVIDER_NAME || 'tilt'

const Wave = (props) => {
    let dividerClass = props.position ? `${dividerName}-divider-${props.position}` : `${dividerName}-divider-top`
    return (
        animation ?
        (
            dividerName === 'tilt' ?
            (
                <div className={dividerClass}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        <path d="M1200 120L0 16.48 0 0 1200 0 1200 120z" className="shape-fill"></path>
                    </svg>
                </div>
            )
            : dividerName === 'arrow' ?
            (
                <div className={dividerClass}>
                    <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none">
                        {
                            props.position === 'top' ?
                            (
                                <path d="M649.97 0L550.03 0 599.91 54.12 649.97 0z" className="shape-fill"></path>
                            )
                            :
                            props.position === 'bottom' ?
                            (
                                <path d="M649.97 0L599.91 54.12 550.03 0 0 0 0 120 1200 120 1200 0 649.97 0z" className="shape-fill"></path>
                            )
                            : null
                        }
                    </svg>
                </div>
            )
            : null
        )
        : (
            <svg className="waveAnimation"
                xmlns="http://www.w3.org/2000/svg"
                xlinkHref="http://www.w3.org/1999/xlink"
                viewBox="0 24 150 28 "
                preserveAspectRatio="none">
                <defs>
                    <path id="gentle-wave"
                        d="M-160 44c30 0
                        58-18 88-18s
                        58 18 88 18
                        58-18 88-18
                        58 18 88 18
                        v44h-352z" />
                </defs>
                <g className="parallax1">
                    <use xlinkHref="#gentle-wave" x="50" y="3" fill={process.env.GATSBY_BRAND_COLOR_1} />
                </g>
                <g className="parallax2">
                    <use xlinkHref="#gentle-wave" x="50" y="0" fill={process.env.GATSBY_BRAND_COLOR_2} />
                </g>
                <g className="parallax3">
                    <use xlinkHref="#gentle-wave" x="50" y="9" fill={process.env.GATSBY_BRAND_COLOR_3} />
                </g>
                <g className="parallax4">
                    <use xlinkHref="#gentle-wave" x="50" y="6" fill="#fff" />
                </g>
            </svg>
        )
    )
}
export default Wave
